import React, { useState, useEffect } from 'react';
import { useLanguage } from '../context/LanguageContext';
import { ArrowRight, Leaf } from 'lucide-react';

const LOGO_URL = "https://customer-assets.emergentagent.com/job_e0d36ff9-afe9-42cc-acb6-596aa3a8fe6f/artifacts/lt33l9w1_6FA12A78-938C-4DE4-9159-597D78E23F7F.png";

const LandingPage = ({ onEnter }) => {
  const { language, toggleLanguage } = useLanguage();
  const [isVisible, setIsVisible] = useState(false);
  const [isExiting, setIsExiting] = useState(false);

  useEffect(() => {
    // Trigger entrance animation
    const timer = setTimeout(() => setIsVisible(true), 100);
    return () => clearTimeout(timer);
  }, []);

  const handleEnter = () => {
    setIsExiting(true);
    // Wait for exit animation then call onEnter
    setTimeout(() => {
      onEnter();
    }, 800);
  };

  return (
    <div className={`landing-page ${isExiting ? 'landing-exit' : ''}`}>
      {/* Animated Background */}
      <div className="landing-bg">
        <div className="landing-bg-gradient"></div>
        <div className="landing-bg-pattern"></div>
        
        {/* Floating elements */}
        <div className="landing-float landing-float-1">
          <Leaf size={40} />
        </div>
        <div className="landing-float landing-float-2">
          <Leaf size={30} />
        </div>
        <div className="landing-float landing-float-3">
          <Leaf size={50} />
        </div>
      </div>

      {/* Language Switcher */}
      <div className={`landing-lang ${isVisible ? 'landing-visible' : ''}`}>
        <button
          onClick={toggleLanguage}
          className="landing-lang-btn"
        >
          {language === 'fr' ? 'EN' : 'FR'}
        </button>
      </div>

      {/* Main Content */}
      <div className="landing-content">
        {/* Logo */}
        <div className={`landing-logo-container ${isVisible ? 'landing-visible' : ''}`}>
          <img 
            src={LOGO_URL} 
            alt="Océana" 
            className="landing-logo"
          />
        </div>

        {/* Tagline */}
        <div className={`landing-tagline ${isVisible ? 'landing-visible' : ''}`}>
          <p className="landing-tagline-text">
            {language === 'fr' 
              ? 'Fruits & Légumes Premium' 
              : 'Premium Fruits & Vegetables'}
          </p>
          <div className="landing-divider"></div>
          <p className="landing-location">
            Abidjan, Côte d&apos;Ivoire
          </p>
        </div>

        {/* Enter Button */}
        <button 
          onClick={handleEnter}
          className={`landing-enter-btn ${isVisible ? 'landing-visible' : ''}`}
          data-testid="landing-enter-btn"
        >
          <span>{language === 'fr' ? 'Entrer' : 'Enter'}</span>
          <ArrowRight size={20} className="landing-arrow" />
        </button>

        {/* Bottom text */}
        <p className={`landing-bottom-text ${isVisible ? 'landing-visible' : ''}`}>
          {language === 'fr' 
            ? 'Qualité • Fraîcheur • Fiabilité' 
            : 'Quality • Freshness • Reliability'}
        </p>
      </div>

      {/* Scroll indicator */}
      <div className={`landing-scroll-hint ${isVisible ? 'landing-visible' : ''}`}>
        <div className="landing-mouse">
          <div className="landing-mouse-wheel"></div>
        </div>
      </div>
    </div>
  );
};

export default LandingPage;
